import {Component} from '@angular/core';

@Component({
  selector: 'ax-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent {}
